export default function setupAttribution(store, {location: {query}}) {
  let utmTrackingJSON;
  for (const key of Object.keys(query)) {
    // pull in utm_ style GET params
    if (key.indexOf('utm') === 0) {
      utmTrackingJSON = utmTrackingJSON || {};
      utmTrackingJSON[key] = query[key];
    }
  }

  const {referrer} = document;
  if (referrer) {
    // pull in the referer if we have one
    if (referrer.indexOf(window.location.host) === -1) {
      // the referrer header is not set to the current site, store it
      utmTrackingJSON = utmTrackingJSON || {};
      utmTrackingJSON.referrer = referrer;
    }
  }

  // track utm tags
  if (utmTrackingJSON) {
    // track utm parts
    utmTrackingJSON.type = 'web';
    utmTrackingJSON.nonInteraction = 1;
    store.tracker.track('Attribution', utmTrackingJSON);
  }
}



// WEBPACK FOOTER //
// ./spa/vendor/attribution.jsx